<!--
     <FieldFile>
-->

<template>
  <div v-if="short && showIcon">
  <v-tooltip bottom >
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        v-bind="attrs"
        v-on="on"
        style="cursor:default;"
        small
        :color="icon_color"
        class="fieldfile-icon"
        @click.stop="downloadFile"
        :disabled="!is_enabled"
      >
        {{ type_icon }}
      </v-icon>
    </template>
    <span class="string-field-content">{{ representation }}</span>
  </v-tooltip>
  </div>

  <span  v-else>
    <field-string
    :field="field"
    :short="true"
    :is_mobile="is_mobile"
    :max_text_size="50"
    css_class=""
    >

    </field-string>
    <v-icon
      v-if="showIcon && field.value"
      small
      :color="icon_color"
      class="fieldfile-icon"
      @click.stop="downloadFile"
      :disabled="!is_enabled"
    >
      {{ type_icon }}
    </v-icon>  
  </span>
</template>

<style lang="scss">
  .fieldfile-icon:after{
    height: unset !important;
  }

.string-field-content {
  text-overflow: ellipsis;
  display: block;
  overflow: hidden;
}
</style>
  
<script>
import FieldString from './FieldString.vue';
import FileIcons from '@/utils/fileicons'

export default {
  name: 'FieldVersionableFile',

  props: {
    field: { required: true },
    short: { type: Boolean, default: false },
    is_mobile: { type: Boolean, default: false },
  },
  components: {
    FieldString
  },

  data(){
    return{
      files: FileIcons,
    }
  },
  
  computed: {
    representation() {
      return '' + this.field;
    },
    showIcon() {
        return !!this.field.download_options;
    },
    is_enabled() {
      return this.field.download_options && this.field.download_options.length >0;
    },
    type_icon() {
        const mimetype = this.field.mimetype()
        return mimetype ? this.files[mimetype].icon : 'mdi-cancel';
    },
    icon_color() {
        const mimetype = this.field.mimetype();
        return mimetype ? this.files[mimetype].color : '';
    }
  },
  methods:{
    downloadFile(){
      this.$emit('download-evidence', this.field)
    }
  },
};
</script>